import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ContactModal.css';

const CALENDLY_URL = 'https://calendly.com/evela-bytesand/bytesand-audit?background_color=1a1a1a&text_color=ffffff&primary_color=d4a574';

const CalendlyModal = ({ isOpen, onClose }) => {
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setShowFallback(false);
    // Remove any previous Calendly widget
    const calendlyEmbed = document.getElementById('calendly-navbar-embed');
    if (calendlyEmbed) calendlyEmbed.innerHTML = '';

    // Load Calendly script if not present
    let script = document.getElementById('calendly-widget-script');
    if (!script) {
      script = document.createElement('script');
      script.id = 'calendly-widget-script';
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.onload = () => {
        // Only initialize if no iframe is present
        const calendlyEmbed = document.getElementById('calendly-navbar-embed');
        if (calendlyEmbed && calendlyEmbed.getElementsByTagName('iframe').length === 0 && window.Calendly) {
          window.Calendly.initInlineWidget({
            url: CALENDLY_URL,
            parentElement: calendlyEmbed,
          });
        }
      };
      document.body.appendChild(script);
    } else {
      // Script already loaded, only initialize if no iframe is present
      setTimeout(() => {
        const calendlyEmbed = document.getElementById('calendly-navbar-embed');
        if (calendlyEmbed && calendlyEmbed.getElementsByTagName('iframe').length === 0 && window.Calendly) {
          window.Calendly.initInlineWidget({
            url: CALENDLY_URL,
            parentElement: calendlyEmbed,
          });
        }
      }, 200);
    }

    // Fallback: if widget doesn't load in 3 seconds, show fallback
    const fallbackTimeout = setTimeout(() => {
      const calendlyEmbed = document.getElementById('calendly-navbar-embed');
      if (calendlyEmbed && calendlyEmbed.getElementsByTagName('iframe').length === 0) {
        setShowFallback(true);
      }
    }, 3000);

    return () => {
      clearTimeout(fallbackTimeout);
      // Optionally, clear the container on close
      const calendlyEmbed = document.getElementById('calendly-navbar-embed');
      if (calendlyEmbed) calendlyEmbed.innerHTML = '';
    };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="modal-container"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
          >
            <div className="modal-header">
              <h2>Book a Call</h2>
              <button className="modal-close-button" onClick={onClose}>×</button>
            </div>
            <div className="modal-content">
              <div id="calendly-navbar-embed" style={{ minWidth: 320, height: 700 }} />
              {showFallback && (
                <div style={{ marginTop: 20, color: '#fff', background: '#1a1a1a', padding: 16, borderRadius: 8 }}>
                  <p>
                    If you don't see the booking form, please disable your ad blocker or{' '}
                    <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" style={{ color: '#d4a574' }}>
                      book directly here
                    </a>.
                  </p>
                </div>
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CalendlyModal; 